import React, { useState, useEffect } from "react";
import { busca_detalhe_lancamento } from "../../services/api";
import AlunosSemNotas from "./alunos_Sem_Nota";

import Table from "react-bootstrap/Table";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Detalhe_lancamento_BS = (props) => {
    const [data2, setData2] = useState([]);
    const [modalData, setModalData] = useState({ show: false, unidade: '', turma: '', sig: '', dis: '' });

    let cod_unidade = props.un;
    let avaliacao = props.av;
    let serie = props.se;

    const fetchData = async () => {
        try {
            const response = await busca_detalhe_lancamento(avaliacao, cod_unidade, serie);
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [avaliacao, serie]);

    const formatPercentage = (value) => {
        if (parseFloat(value) < 100) {
            return `${parseFloat(value).toFixed(2)}%`;
        }
        return "100.00%";
    };

    return (
        <div className="LancamentoDetalhe" style={{ border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5><b>
                    Detalhamento de lançamento
                </b>
                </h5>
                <h6>
                    Quantidade de alunos e notas lançadas por turma. Clique na linha para ver quais alunos estão sem nota.
                </h6>
            </center>
            <br />
            <Table striped bordered hover responsive size="sm">
                <thead>
                    <tr>
                        <th>Turma</th>
                        <th>Qtd Alunos</th>
                        <th>Disciplina</th>
                        <th>Qtd Notas</th>
                        <th>%</th>
                        <th>Professor</th>
                        <th>Prazo</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => {
                        const percentage = parseFloat(item.perc);
                        let textColor = "black";
                        let bgColor = "white";

                        switch (true) {
                            case (percentage >= 92):
                                textColor = "black";
                                bgColor = "lightgreen";
                                break;
                            case (percentage >= 75):
                                textColor = "black";
                                bgColor = "yellow";
                                break;
                            case (percentage >= 50):
                                textColor = "white";
                                bgColor = "orange";
                                break;
                            case (percentage >= 30):
                                textColor = "white";
                                bgColor = "red";
                                break;
                            case (percentage >= 15):
                                textColor = "white";
                                bgColor = "darkred";
                                break;
                            case (percentage >= 0):
                                textColor = "white";
                                bgColor = "black";
                                break;
                            default:
                                textColor = "inherit";
                                bgColor = "white";
                        }

                        return (
                            <>
                                <tr
                                    key={index}
                                    onClick={() => setModalData({ show: true, unidade: cod_unidade, turma: item.turma, sig: avaliacao, dis: item.disciplinas })}
                                    style={{ cursor: "pointer" }}
                                >
                                    <td>{item.turma}</td>
                                    <td>{parseInt(item.alunos)}</td>
                                    <td>{item.dsc}</td>
                                    <td>{parseInt(item.notas) || ''}</td>
                                    <td style={{ color: textColor, backgroundColor: bgColor }}>
                                        {formatPercentage(item.perc)}
                                    </td>
                                    <td>{item.professor}</td>
                                    <td>{item.dtf}</td>
                                </tr>

                                {modalData.show && (
                                    <Modal show={modalData.show} onHide={() => setModalData({ ...modalData, show: false })}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Alunos Sem Nota</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <AlunosSemNotas
                                                un={modalData.unidade}
                                                tu={modalData.turma}
                                                sig={modalData.sig}
                                                dis={modalData.dis}
                                            />
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={() => setModalData({ ...modalData, show: false })}>
                                                Fechar
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                )}
                            </>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default Detalhe_lancamento_BS;
